import { useState } from "react";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { AppsMarquee } from "./components/landing/AppsMarquee";
import { Features } from "./components/landing/Features";
import { Pricing } from "./components/landing/Pricing";
import { AppsDownload } from "./components/landing/AppsDownload";
import { Devices } from "./components/landing/Devices";
import { Testimonials } from "./components/landing/Testimonials";
import { FAQ } from "./components/landing/FAQ";
import { SeoContent } from "./components/landing/SeoContent";
import { Footer } from "./components/landing/Footer";
import { LeadModal } from "./components/landing/LeadModal";
import { FloatingWhatsApp } from "./components/landing/FloatingWhatsApp";

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("geral");

  const openLeadModal = (plan = "geral") => {
    setSelectedPlan(plan);
    setModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white overflow-x-hidden">
      <Header onCta={openLeadModal} />
      <main>
        <Hero onCta={openLeadModal} />
        <AppsMarquee />
        <Features />
        <Pricing onCta={openLeadModal} />
        <AppsDownload onCta={openLeadModal} />
        <Devices />
        <Testimonials />
        <FAQ />
        <SeoContent />
      </main>
      <Footer />
      <FloatingWhatsApp onClick={() => openLeadModal("whatsapp")} />
      <LeadModal open={modalOpen} onOpenChange={setModalOpen} plan={selectedPlan} />
    </div>
  );
}

export default App;
